export const restrictedRoutes = [
    '/admin/business',
    '/admin/plans',
    '/admin/plans/add',
    '/admin/coupons',
    '/admin/coupons/add',
    '/admin/categories',
    '/admin/categories/add',
    '/admin/module-settings',
];